import React from 'react';

import { Icon } from '../icons';

export const RadioFilledIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 14 14" fill={color} style={style}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 13.3C10.4794 13.3 13.3 10.4794 13.3 7C13.3 3.52061 10.4794 0.7 7 0.7C3.52061 0.7 0.7 3.52061 0.7 7C0.7 10.4794 3.52061 13.3 7 13.3ZM7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
        />
        <circle cx="6.99998" cy="7" r="4.66667" />
      </g>
    </svg>
  );
};
